<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Hozzáférés megtagadva</ion-title>
    <!--ion-buttons slot="end">
      <ion-button color="primary">
        <ion-icon slot="icon-only" name="create"></ion-icon>
      </ion-button>
      <ion-button color="danger">
        <ion-icon slot="icon-only" name="trash"></ion-icon>
      </ion-button>
    </ion-buttons-->
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">

  <div class="container">
    <div class="forbidden-sign"></div>
    <h1>Hozzáférés megtagadva</h1>
    <p>Győződj meg róla, hogy megfelelő jogosultságokkal rendelkezel!</p>
  </div>
</ion-content>
